import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/views/home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '',
        name: 'HomeIndex',
        component: () => import('@/views/home/index.vue')
      },
      {
        path: 'merch',
        name: 'Merch',
        component: () => import('@/views/gift/index.vue'),
        meta: {
          title: '周边及礼物'
        }
      },
      {
        path: 'dynamic',
        name: 'Dynamic',
        component: () => import('@/views/dynamic/index.vue')
      },
      {
        path: 'replay',
        name: 'Replay',
        component: () => import('@/views/replay/index.vue')
      },
      {
        path: 'creation',
        name: 'Creation',
        component: () => import('@/views/creation/index.vue')
      },
      {
        path: 'fan-creation',
        name: 'FanCreation',
        component: () => import('@/views/fan-creation/index.vue')
      },
      {
        path: 'daughters',
        name: 'Daughters',
        component: () => import('@/views/daughters/index.vue')
      },
      {
        path: 'galgame',
        name: 'Galgame',
        component: () => import('@/views/galgame/index.vue')
      },
      {
        path: 'archive',
        name: 'Archive',
        component: () => import('@/views/archive/index.vue')
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/views/about/index.vue')
      },
      {
        path: 'friends',
        name: 'Friends',
        component: () => import('@/views/friends/index.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
